import React from "react";

const SvgIcnSettingRoom = props => (
  <svg
    id="icn_setting_room_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>
        {
          ".icn_setting_room_svg__cls-1,.icn_setting_room_svg__cls-2{fill:#4d4d4d}.icn_setting_room_svg__cls-1{fill-rule:evenodd}"
        }
      </style>
    </defs>
    <path
      className="icn_setting_room_svg__cls-1"
      d="M14 5.93a2 2 0 0 1-4.08 0 2 2 0 1 1 4.08 0zM21 7.93a2 2 0 1 1-4.08 0 2 2 0 1 1 4.08 0zM7 7.93a2 2 0 0 1-4 0 2.1 2.1 0 0 1 2-2.11 2.1 2.1 0 0 1 2 2.11z"
    />
    <path
      className="icn_setting_room_svg__cls-2"
      d="M12 8.48c-1.24 0-2.31 1.28-2.92 3.19A10.68 10.68 0 0 1 10 14a16.68 16.68 0 0 1 2 0 16.68 16.68 0 0 1 2 0 10.68 10.68 0 0 1 .92-2.33c-.61-1.91-1.68-3.19-2.92-3.19zM22 17c.17-.21.31.34.44.09 0-3.66-1.56-6.61-3.44-6.61-1.4 0-2.46 1.17-3 3.52a11.77 11.77 0 0 1 6 3zM8 14c-.54-2.35-1.6-3.52-3-3.52-1.88 0-3.41 2.95-3.44 6.61.13.25.27-.3.44-.09a11.77 11.77 0 0 1 6-3z"
    />
    <path
      className="icn_setting_room_svg__cls-1"
      d="M12 16c-5.52 0-9 3.13-9 4h18c0-.87-3.48-4-9-4z"
    />
  </svg>
);

export default SvgIcnSettingRoom;
